import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';

import loading from '@/utils/loading.js'


Vue.use(Router)
Vue.use(ElementUI)
Vue.use(loading)
Vue.use(mavonEditor)

Vue.config.productionTip = false

const routes = [
  {
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: false
  },
  {
    path: '/',
    alias: "/main",
    component: () => import('@/views/main/Main'),
    hidden: true,
    children: [
      {
        path: 'user',
        component: () => import('@/views/main/childs/system/User'),
        name: 'User',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
      {
        path: 'client',
        component: () => import('@/views/main/childs/system/Client'),
        name: 'Client',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
      {
        path: 'role',
        component: () => import('@/views/main/childs/system/Role'),
        name: 'Role',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
      {
        path: 'phrase',
        component: () => import('@/views/main/childs/content/Phrase'),
        name: 'Phrase',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
      {
        path: 'article',
        component: () => import('@/views/main/childs/content/Article'),
        name: 'Article',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
      {
        path: 'website',
        component: () => import('@/views/main/childs/content/Website/Website.vue'),
        name: 'Website',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
      {
        path: 'location',
        component: () => import('@/views/main/childs/content/Location/Location.vue'),
        name: 'Location',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
      {
        path: 'service',
        component: () => import('@/views/main/childs/system/Service'),
        name: 'Service',
        meta: { title: 'Clipboard', icon: 'clipboard' }
      },
    ]
  }
]

const router = new Router({
  routes
})

var vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

export default vue